<div *ngIf="strategies$ | async"><!-- trigger loading strategies --></div>


<div class="sideBtnPanel">
  <button class="btn btn-primary"
          name="settings-btn"
          ng-class="{'btn-right-open': open}"
          (click)="openSettings()"><i class="glyphicon glyphicon-cog"></i>&nbsp;&nbsp;&nbsp;Settings
  </button>

</div>

<div class="row" *ngIf="viewModel$ | async as viewModel">
  <div class="col-md-12">
    <div class="form-inline">
      <h1 class="heading">
        <span>{{'_PatientsHeader_' | translate}}</span>
        <div style="display: inline-table; width: 64px; height: 32px;">
          &nbsp;
          <img [hidden]="!viewModel.loading" alt="Loading...."
               src="/img/loading.gif" style="width: 28px; height: 28px;"/>
        </div>
        <ng-container *ngIf="userRoute$ | async as userRoute">
          <patient-search (patientSelect)="selectPatient($event, userRoute.param)"></patient-search>
        </ng-container>

        <div class="pull-right">
          <!-- TODO: remove refresh and get it from websocket update instead???-->
          <button class="btn btn-sm btn-primary" (click)="refreshPatient(viewModel.selectedPatient.personId)"
                  [disabled]="viewModel.loading || viewModel.selectedPatient === undefined">
            Refresh
          </button>
        </div>

      </h1>
    </div>
  </div>

  <div *ngIf="selectedPatient$ | async as selectedPatient">

    <patient-details
        [selectedPatient]="selectedPatient"
        [hasTwoWay]="hasTwoWay$ | async">
    </patient-details>
    <div class="row" style="padding-left: 33px;">
      <ng-template [featureFlags]="['resource:pets']" *ngIf="selectedPatient.petsDetail.length > 0">
        <h2 class="heading">
          <span>{{'_PetsHeader_' | translate}}</span>
        </h2>
        <pets-detail [selectedPatient]="selectedPatient"></pets-detail>
      </ng-template>
    </div>
    <div class="row" style="padding-left: 15px;">
      <patient-reminder-settings
          [selectedPatient]="selectedPatient"
          [selectedPatientStrategy]="selectedPatientStrategy$ | async"
          [strategies]="patientStrategies$ | async"
          (strategyChanged)="setStrategy($event, selectedPatient.personId)">
      </patient-reminder-settings>
    </div>

    <div class="col-md-12" style="padding-top: 16px; padding-left: 13px;">
      <patient-tabs [patientId]="selectedPatient.personId"></patient-tabs>
    </div>

  </div>
</div>
